import React, { useEffect, useState } from "react";
import PageHero from "@/components/public/PageHero";
import api from "@/lib/api";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

export default function Faq() {
  const [items, setItems] = useState([]);
  const [cat, setCat] = useState("All");

  useEffect(() => { api.get("/content/faq?published_only=true").then((r) => setItems(r.data)).catch(() => {}); }, []);

  const cats = ["All", ...Array.from(new Set(items.map((i) => i.category).filter(Boolean)))];
  const filtered = items.filter((i) => cat === "All" || i.category === cat);

  return (
    <div>
      <PageHero overline="Support" title="Frequently Asked Questions" subtitle="Everything you need to know about accounts, platforms and funding." />
      <section className="py-16 sm:py-24 bg-white">
        <div className="cb-container max-w-3xl">
          <div className="flex flex-wrap gap-2 mb-8">
            {cats.map((c) => (
              <button key={c} onClick={() => setCat(c)} className={`px-3 py-2 text-sm rounded transition-colors ${cat === c ? "btn-gold" : "text-slate-700 border border-slate-200 hover:border-[#D8AE4E]/50"}`} data-testid={`faq-cat-${c.toLowerCase().replace(/\s+/g, "-")}`}>{c}</button>
            ))}
          </div>
          {filtered.length === 0 ? <p className="text-slate-500">No questions found.</p> : (
            <Accordion type="single" collapsible className="space-y-3">
              {filtered.map((f) => (
                <AccordionItem key={f.id} value={f.id} className="cb-card px-6 border-b" data-testid={`faq-item-${f.id}`}>
                  <AccordionTrigger className="text-[#0B1D40] hover:no-underline text-left">{f.question}</AccordionTrigger>
                  <AccordionContent className="text-slate-500 leading-relaxed">{f.answer}</AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          )}
        </div>
      </section>
    </div>
  );
}
